import { motion } from "framer-motion";

// Fades + lifts content in the first time it scrolls into view.
const Reveal = ({ children, delay = 0, className = "", as = "div", ...rest }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y: 40, filter: "blur(6px)" }}
      whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, ease: "easeOut", delay }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
